import React from "react";
import { cn } from "@/lib/utils";

// Aura ring around an avatar. Selective spectrum usage.
export function AuraRing({ src, size = 48, alt = "", active = true, className, ring = 2, onClick, fallback = "", story = false, storySeen = false }) {
  const inner = size - ring * 2 - 3;
  const initial = (fallback || alt || "?").trim().charAt(0).toUpperCase();
  const ringClass = story
    ? (storySeen ? "bg-am-border-strong" : "aura-ring-bg")
    : (active ? "aura-ring-bg" : "bg-white/10");
  return (
    <span
      onClick={onClick}
      className={cn(
        "relative inline-flex items-center justify-center rounded-full",
        ringClass,
        onClick && "cursor-pointer",
        className
      )}
      style={{ width: size, height: size, padding: story ? ring + 1 : ring }}
    >
      <span className="flex items-center justify-center rounded-full bg-am-bg" style={{ width: size - ring * 2, height: size - ring * 2, padding: 2 }}>
        {src ? (
          <img
            src={src}
            alt={alt}
            className="rounded-full object-cover"
            style={{ width: inner, height: inner }}
            draggable={false}
          />
        ) : (
          <span className="flex items-center justify-center rounded-full bg-am-surface3 font-bold text-am-text2" style={{ width: inner, height: inner, fontSize: inner * 0.4 }}>{initial}</span>
        )}
      </span>
    </span>
  );
}

// Small aura metric pill: "4.8M Aura"
export function AuraPill({ value, className, label = "Aura" }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border border-aura-magenta/25 bg-am-surface2 px-2.5 py-1 text-xs font-semibold text-white",
        className
      )}
      style={{ boxShadow: "0 0 14px rgba(255,46,147,0.14)" }}
    >
      <span className="h-1.5 w-1.5 rounded-full aura-radial" />
      {value} <span className="text-am-text2 font-medium">{label}</span>
    </span>
  );
}
